<template>
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216 216" fill="currentColor">
    <path d="M122.14 207.06H93.86v-37.21h-58.8L77.68 113h-28.9l33.68-44.95H63.71L108 8.94l44.29 59.11h-18.75L167.22 113h-28.9l42.62 56.87h-58.8zm-20-8.29h11.72v-37.21h50.51l-42.62-56.87h28.9L117 59.76h18.74L108 22.77l-27.73 37H99l-33.65 44.92h28.9l-42.62 56.87h50.51z"/>
</svg>

</template>